import * as axios from "axios";
import { getAuthHeader, removeAllCookies } from "../utils";

export const getHolidayListForYear = (year: number) => {
  const url = `${process.env.REACT_APP_BASE_URL}master/holiday-year?y=${year}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getHolidayList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}master/holiday`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const addDepartmentList = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}master/department/add`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const addGradeList = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}master/grade/add`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const addGroupList = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}master/group/add`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const addDesignationList = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}master/designation/add`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const addUnitList = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}master/unit/add`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const addHoliday = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}master/holiday/add`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const addNotingList = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}master/noting/add`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

/**\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ UPDATE REQUEST //////////////////////////////////////////*/

export const updateDesignationList = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}master/designation/update`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const updateNotingList = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}master/noting/update`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const updateHoliday = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}master/holiday/update`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

/**\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ GET REQUEST /////////////////////////////////////////////*/

export const getDepartmentList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}master/department`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
      removeAllCookies();
      localStorage.removeItem("timer");
      window.location.pathname = "/";
    }
  );
};

export const getMedicalCategoryList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}medical/category/list`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getMedicalList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}medical/claim/list`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getMedicalListForDesk = () => {
  const url = `${process.env.REACT_APP_BASE_URL}medical/desk/file/list`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getFinanceMedicalFileList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}finance/medical/files`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const deleteSingleFile = (fileData: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}delete/dpt/files`;
  return axios.post(url, fileData, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getFileNameByDepartment = (
  dptCode: any,
  page: any,
  limit: any
) => {
  const url = `${process.env.REACT_APP_BASE_URL}department/files/${dptCode}/${page}/${limit}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getGradeList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}master/grade`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getGroupList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}master/group`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getDesignationList = (sort: number) => {
  const url = `${process.env.REACT_APP_BASE_URL}master/designation?s=${sort}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getUnitList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}master/unit`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getAvailableNotings = () => {
  const url = `${process.env.REACT_APP_BASE_URL}master/notings`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getEtoorAvailableNotings = () => {
  const url = `${process.env.REACT_APP_BASE_URL}etoor/notings`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getNotingsList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}master/noting-list`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getLeaveType = () => {
  const url = `${process.env.REACT_APP_BASE_URL}master/leave-type`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getLeaveStatus = () => {
  const url = `${process.env.REACT_APP_BASE_URL}master/leave-status`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getUserType = () => {
  const url = `${process.env.REACT_APP_BASE_URL}master/user-type`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getLoginStatus = () => {
  const url = `${process.env.REACT_APP_BASE_URL}master/login-status`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getLeaveAvailingStatus = () => {
  const url = `${process.env.REACT_APP_BASE_URL}master/leave-availing-status`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getDesignationDetail = (code: string) => {
  const url = `${process.env.REACT_APP_BASE_URL}master/designation/${code}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getNotingDetail = (code: string) => {
  const url = `${process.env.REACT_APP_BASE_URL}master/noting/${code}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getHolidayDetail = (code: string) => {
  const url = `${process.env.REACT_APP_BASE_URL}master/holiday/${code}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getPermissionList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}master/permission`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getVersion = () => {
  const url = `${process.env.REACT_APP_BASE_URL}master/version`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getAddressType = () => {
  const url = `${process.env.REACT_APP_BASE_URL}master/address-type`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getEncashmentStatus = () => {
  const url = `${process.env.REACT_APP_BASE_URL}master/encashment-status`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getDashboardLinks = () => {
  const url = `${process.env.REACT_APP_BASE_URL}master/dashboard-links`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const addDashboardLink = (formData: FormData) => {
  const header = getAuthHeader();
  const url = `${process.env.REACT_APP_BASE_URL}master/dashboard-links/add`;
  return axios.post(url, formData, {
    ...header,
    headers: { ...header.headers, "Content-Type": "multipart/form-data" },
  }).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const deleteDashboardLink = (id: number) => {
  const url = `${process.env.REACT_APP_BASE_URL}master/dashboard-links/${id}`;
  return axios.delete(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};
